import { useQuery } from "@tanstack/react-query";
import { getBackendUrl } from "api/common";
import { axiosClient } from "api/http/config";
import { isAxiosError } from "axios";
import { PlanEventInformation } from "features/CenterContent/RoleContent/AlternativeTransport/MeasureOverview/types";
import { CombinedHistoryResponse } from "shared/types/operationalInformation";
import { Nullish } from "shared/utils/objectUtils";

export function usePreviousEventVersion({
  uuid,
  version,
}: CombinedHistoryResponse) {
  const { data, status } = useQuery({
    queryKey: ["previousEventVersion", uuid, version],
    enabled: Boolean(uuid && version),
    queryFn: async ({ signal }): Promise<Nullish<PlanEventInformation>> => {
      const response = await axiosClient
        .get<PlanEventInformation>(
          `${getBackendUrl()}/operational-information/${uuid}/${version}/previous`,
          { signal },
        )
        .catch((err) => {
          if (isAxiosError(err) && err.status === 404) {
            return err.response;
          }
          throw err;
        });

      if (response?.status === 404) return null;
      return response?.data;
    },
    retry: false,
  });

  return { data, status };
}
